<mat-card>
    <mat-card-title><prl-label value="label.login"/></mat-card-title>
    <mat-card-content>
        <form [formGroup]="form" class="mxs-form" (keydown.enter)="$event.stopPropagation(); login()">
            <mat-form-field class="mxs-input">
                <mat-label><prl-label value="label.username"/></mat-label>
                <input type="text" matInput formControlName="username">
            </mat-form-field>

            <mat-form-field class="mxs-input">
                <mat-label><prl-label value="label.password"/></mat-label>
                <input type="password" matInput formControlName="password">
            </mat-form-field>
            <mat-checkbox class="mxs-checkbox" formControlName="remember-me"><prl-label value="label.login.remember.me"/></mat-checkbox>
            <a class="reset-password" (click)="showResetPassword()"><prl-label value="label.reset.password"/></a>

            @if (error) {
                <div class="error">
                    <prl-label value="label.errors.mandatory"/>
                </div>
            }

            <div class="button">
                <mx-button [buttonModel]="loginButton"></mx-button>
            </div>

            @if (!isRegistrationDisabled) {
                <div class="registration">
                    <span><prl-label value="label.login.dont.have.user"/></span>&nbsp;
                    <a [routerLink]="['/registration']">
                        <prl-label value="label.login.register.now"/>
                    </a>
                </div>
            }

            <div class="contact-us">
                <a [routerLink]="['/contact-us']"><prl-label value="label.contact.us"/></a>
            </div>
        </form>
    </mat-card-content>
</mat-card>
